import { pipe } from '../pipe.js';
import { rewireSchema } from './rewire-schema.js';
import { resolveDisplayMode } from './resolve-display-mode.js';
import { resolveDisplayZone } from './resolve-display-zone.js';
import { recalculatePositions } from './recalculate-positions.js';
import { rewireBackgrounds } from './rewire-backgrounds.js';
import { generateStyles } from './style-generator/generate-styles.js';
import { mapWidgetImpl } from './map-widget-impl.js';
import { patchAutoFocusable } from './patch-auto-focusable.js';
import { addBullets } from './add-bullets.js';
import { addTransitions } from './add-transitions.js';
import { generateAssetsList } from './generate-assets-list.js';
import { validateStyles } from './validate-styles.js';
import { addViewportMatcher } from '#/providers/creative/prepare-creative/add-viewport-matcher.js';

const prepareCreativeSchema = pipe(
  liftUpData,
  resolveDisplayZone,
  resolveDisplayMode,
  addViewportMatcher,
  rewireSchema,
  addBullets,
  addTransitions,
  generateAssetsList,
  rewireBackgrounds,
  patchAutoFocusable,
  recalculatePositions,
  generateStyles,
  validateStyles,
  mapWidgetImpl,
);

export default prepareCreativeSchema;

/** lift-up locale data and return ONLY `data` */
function liftUpData(schema) {
  return Object.assign(schema.data, schema.i18nEntities, {
    id: schema._id,
    idHash: schema.idHash,
  });
}
